<div
    [id]="'coupon-detail-modal' + index()"
    class="coupon-detail-container"
    tabindex="0"
    [ngClass]="{'selected': isSelected()}"
    [attr.aria-disabled]="disabled() || loading() || anotherCouponLoading()"
     (click)="handleSelection($event)"
    (keydown.enter)="handleSelection($event)"
    (keydown.space)="handleSelection($event); $event.preventDefault()"
>
    <div class="primary-container">
        <div class="coupon-information-group">
            <span class="name" [ngClass]="{'selected': isSelected()}">{{ coupon().name }}</span>
            @if(coupon().type !== couponType.OPTIONAL){
                <span class="code" [ngClass]="{'selected': isSelected()}" [attr.aria-label]="coupon().code">{{ coupon().code }}</span>
            } @else {
                <div aria-hidden="true" style="height: 1.25rem;"></div>
            }
            @if (coupon().expirationDate) {
                <span class="expires-wrapper">
                    <span class="expires" [ngClass]="{'selected': isSelected()}">{{'shared_components.coupons.expires' | transloco}}</span>
                    &nbsp;
                    <span class="date" [ngClass]="{'selected': isSelected()}">{{ formatDate(coupon().expirationDate!) }}</span>
                </span>
            }
        </div>

        @if (!disabled()) {
            @if(loading()){
                <div class="loading-wrapper">
                    <div class="base-spinner" [style.--primary]="isSelected() ? 'white' : undefined"></div>
                </div>
            } @else {
            <button [id]="'coupon-detail-modal-claim' + index()" class="button-accent-secondary action-button" [ngClass]="{'selected': isSelected()}" (click)="handleClaimClick($event)">
               {{ isSelected() ? ('shared_components.coupons.unclaim' | transloco ): ('shared_components.coupons.claim' | transloco) }}
            </button>
        }
        }
    </div>


    @if (coupon().instructions) {
        <cwo-expandable-component class="expandable-wrapper" [headerStyle]="'left'" [showContentOnHeader]="true" [ariaControlsName]="'ClickMe'" (isExpanded)="handleExpandation($event)">
            <ng-template #heading>
                <div class="header-wrapper">
                    <cwo-text-button [tag]="'span'" [focusable]="false" [ariaLabel]="expanded ? 'View Less' : 'View More'" [color]="isSelected() ? 'var(--white)' : 'var(--primary-dark)'" [iconName]="iconNameType.arrow" [iconPosition]="'right'" [iconRotation]="expanded ? 180 : 0">
                        {{expanded ? 'View Less' : 'View More'}}
                    </cwo-text-button>
                </div>
            </ng-template>
            <ng-template #content>
                <div class="content-wrapper">
                    <span class="instruction" [ngClass]="{'selected': isSelected()}">{{ coupon().instructions }}</span>
                </div>
            </ng-template>
        </cwo-expandable-component>
    }
</div>